import { FC, useEffect } from 'react';
import { useFormikContext } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import DiskCleanupTool from 'components/DiskCleanupTool';
import TableCell from '@mui/material/TableCell';
import DiskCleanupResult from 'components/DiskCleanupResult';

import { useAvoidSuspense } from 'lib';
import { useDiskCleanup } from 'components/DiskCleanupContext';

import { DiskCleanupFormValues } from 'components/DiskCleanup';
import Query, {
  DiskCleanupStorageRefetchQuery,
} from '__generated__/DiskCleanupStorageRefetchQuery.graphql';
import { DiskCleanupStorage_data$key } from '__generated__/DiskCleanupStorage_data.graphql';

type Props = {
  data: DiskCleanupStorage_data$key;
};

const DiskCleanupStorage: FC<Props> = props => {
  const { setStatus } = useDiskCleanup();

  const [data, { loading, refetch }] = useAvoidSuspense<
    DiskCleanupStorageRefetchQuery,
    DiskCleanupStorage_data$key
  >(
    graphql`
      fragment DiskCleanupStorage_data on Query
      @refetchable(queryName: "DiskCleanupStorageRefetchQuery") {
        diskCleanerScan(input: $input) @include(if: $scan) {
          storage {
            ...DiskCleanupResult_cleanInfo
          }
        }
      }
    `,
    props.data,
    Query
  );

  const { values } = useFormikContext<DiskCleanupFormValues>();

  const { storage } = values;

  useEffect(() => {
    if (!storage.selected) return;

    refetch({
      scan: true,
      input: {
        storage,
      },
    });
  }, [refetch, storage]);

  useEffect(() => {
    setStatus('storage', loading);
  }, [loading, setStatus]);

  return (
    <DiskCleanupTool name="storage" title="Palaidi nuotraukų failai">
      <TableCell></TableCell>

      <TableCell>
        <DiskCleanupResult
          title="Failai"
          loading={loading}
          cleanInfo={data.diskCleanerScan?.storage ?? null}
        />
      </TableCell>
    </DiskCleanupTool>
  );
};

export default DiskCleanupStorage;
